module.exports = __webpack_public_path__ + "static/media/img38.d8d22179.jpg";